import SuperMatch from './pages/details/SuperMatch';
import SuperMatches from './pages/list/SuperMatches';

const superMatchRoutes = [
  {
    path: '/accounts/:aid/super-matches/',
    component: SuperMatches,
    exact: true,
  },
  {
    path: '/accounts/:aid/super-matches/:id',
    component: SuperMatch,
    exact: true,
  }
];

export default superMatchRoutes;
